import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedEspaceApiService } from './espace-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class EspaceApiService extends GeneratedEspaceApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
